const initialState = { lang: 'fr' }

function reduceLang(state = initialState, action) {
  let nextState
  switch (action.type) {
    case 'UPDATE_LANG':
      nextState = {
        ...state,
        lang: action.lang
      }
      return nextState || state
  default:
    return state
  }
}

export default reduceLang